import i18n from "@/plugins/i18n";

export const tabs = [
  {
    id: "1",
    key: "MEMBER",
    label: i18n.t("tabs.member"),
  },
  {
    id: "2",
    key: "ACCOUNT",
    label: i18n.t("tabs.account"),
  },
  {
    id: "3",
    key: "PAPER",
    label: i18n.t("tabs.publication"),
  },
  {
    id: "4",
    key: "REVIEW",
    label: i18n.t("tabs.review"),
  },
  {
    id: "5",
    key: "ETC",
    label: i18n.t("tabs.etc"),
  },
];
